import React from 'react';
import styled from '@emotion/styled';
import { Link } from '../../primitives';
import { rem } from 'polished';

const StyledMetanav = styled.nav`
  display: inline-flex;
  width: 100%;

  a {
    padding: ${rem(12)};
    margin-left: ${rem(10)};
    white-space: nowrap;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Metanav = ({ variant, items }: MetanavProps) => {
  return (
    <StyledMetanav>
      {items.map((item: any, index: number) => {
        return (
          <Link
            linkText={item.navigationTitle}
            key={index}
            link={{
              href: item.href,
              title: `${item.navigationTitle}`,
            }}
            color="light"
          />
        );
      })}
    </StyledMetanav>
  );
};

export type MetanavProps = {
  /** Variant Name of the Metanav - possible values: **emphasized** */
  variant?: 'horizontal' | 'vertical';
  /** Class of the Metanav */
  className?: string;
  items: any;
};

export default Metanav;
